<template>
    <form>
        <div class="row q-col-gutter-md">
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-select
                    v-model="PaymentMethodObj.country_id"
                    :label="$t('payment-methods.outgoing.table_titles.country')"
                    emit-value
                    map-options
                    option-value="id"
                    option-label="name"
                    :options="countries"
                    :loading="loading"
                    :error="PaymentMethodObj.errors.has('country_id')"
                    :error-message="PaymentMethodObj.errors.get('country_id')"
                    :rules="[ val => val && val > 0 || $t('payment-methods.outgoing.table_titles.country')+' is required!']"
                    color="input-color"
                >
                    <template v-slot:option="scope">
                        <q-item
                            v-bind="scope.itemProps"
                            v-on="scope.itemEvents"
                            style="border-bottom:1px solid #999"
                        >
                            <q-item-section avatar>
                                <q-icon :name="scope.opt.acronym" size="xs"/>
                            </q-item-section>
                            <q-item-section>
                                <q-item-label>{{ scope.opt.name }}</q-item-label>
                            </q-item-section>
                        </q-item>
                    </template>
                </q-select>
            </div> <!-- COUNTRY -->
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-input
                    v-model="PaymentMethodObj.type"
                    :label="$t('payment-methods.outgoing.table_titles.type')"
                    lazy-rules
                    :error="PaymentMethodObj.errors.has('type')"
                    :error-message="PaymentMethodObj.errors.get('type')"
                    :rules="[ val => val && val.length > 0 || $t('payment-methods.outgoing.table_titles.type')+' is required!']"
                    color="input-color"
                />
            </div> <!-- TYPE -->
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-input
                    v-model="PaymentMethodObj.info_label1"
                    :label="$t('payment-methods.outgoing.table_titles.info_label1')"
                    lazy-rules
                    :error="PaymentMethodObj.errors.has('info_label1')"
                    :error-message="PaymentMethodObj.errors.get('info_label1')"
                    :rules="[ val => val && val.length > 0 || 'Label 1 is required!']"
                    color="input-color"
                />
            </div> <!-- LABEL 1 -->
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-input
                    v-model="PaymentMethodObj.info_label2"
                    :label="$t('payment-methods.outgoing.table_titles.info_label2')"
                    lazy-rules
                    :error="PaymentMethodObj.errors.has('info_label2')"
                    :error-message="PaymentMethodObj.errors.get('info_label2')"
                    color="input-color"
                />
            </div> <!-- LABEL 2 -->

            <div class="col-12">
                <q-editor
                    v-model="PaymentMethodObj.instructions"
                    :dense="$q.screen.lt.md"
                    :toolbar="[
                        [
                            {
                              label: $q.lang.editor.align,
                              icon: $q.iconSet.editor.align,
                              fixedLabel: true,
                              options: ['left', 'center', 'right', 'justify']
                            }
                        ],
                        ['bold', 'italic', 'strike', 'underline'],
                        ['hr', 'link'],
                        ['foreColor', 'backColor'],
                        ['unordered', 'ordered'],
                        ['fields'],
                        ['removeFormat', 'viewsource'],
                        ['undo', 'redo']
                    ]"
                    :fonts="{
                        arial: 'Arial',
                        arial_black: 'Arial Black',
                        comic_sans: 'Comic Sans MS',
                        courier_new: 'Courier New',
                        impact: 'Impact',
                        lucida_grande: 'Lucida Grande',
                        times_new_roman: 'Times New Roman',
                        verdana: 'Verdana'
                    }"
                />
                <template slot="error">
                    {{PaymentMethodObj.errors.get('instructions')}}
                </template>
            </div> <!-- INSTRUCTIONS -->

            <div class="col col-xs-12 col-sm-6 col-md-6">
                <p class="text-caption q-pb-xs" style="margin:0">{{$t('payment-methods.outgoing.table_titles.bank_required')}}</p>
                <q-toggle
                    v-model="PaymentMethodObj.bank_required"
                    checked-icon="fa fa-check"
                    color="input-color"
                    unchecked-icon="fa fa-times"
                    :label="PaymentMethodObj.bank_required ? 'Yes' : 'No'"
                />
            </div> <!-- BANK REQUIRED -->
            <div class="col col-xs-12 col-sm-6 col-md-6">
                <p class="text-caption q-pb-xs" style="margin:0">{{$t('payment-methods.outgoing.table_titles.is_default')}}</p>
                <q-toggle
                    v-model="PaymentMethodObj.is_default"
                    checked-icon="fa fa-check"
                    color="positive"
                    unchecked-icon="fa fa-times"
                    :label="PaymentMethodObj.is_default ? 'Yes' : 'No'"
                />
            </div> <!-- IS DEFAULT -->
        </div>
    </form>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
    name: 'Form',
    model: {
        prop: 'PaymentMethodObj',
        event: 'change'
    },
    props: {
        PaymentMethodObj: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters(['countries'])
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        ...mapActions(['set_countries']),
        submit() {
            this.$emit('submit')
        },
    },
    created() {
        if (! this.countries.length) {
            this.loading = true
            this.set_countries().then(() => {this.loading = false}).catch(() => {this.loading = false})
        }
    },
    components: {},
}
</script>

<style scoped>

</style>
